import React, {
    ReactNode,
    createContext,
    useContext,
    useMemo
} from 'react';

import { Tag } from "../../../API";

interface TagsContext {
    tags: Array<Tag>;
    createTag?: (tagName: string) => Promise<Tag>;
    tagIdToTagMap: Map<string, Tag>;
}

const TagsContext = createContext<TagsContext | undefined>(undefined);

export const TagsContextProvider: React.FC<{ children: ReactNode; value: Omit<TagsContext, "tagIdToTagMap"> }> = ({ children, value }) => {
    const tagIdToTagMap = useMemo<Map<string, Tag>>(() => {
        return value.tags.reduce((map, tag) => {
            map.set(tag.id, tag);
            return map;
        }, new Map<string, Tag>());
    }, [value.tags]);

    return (
        <TagsContext.Provider value={{ ...value, tagIdToTagMap }}>
            {children}
        </TagsContext.Provider>
    );
};

export const useTags = (): TagsContext => {
    const context = useContext(TagsContext);
    if (!context) {
        throw new Error('useTags must be used within a tagsContextProvider');
    }
    return context;
};